<div matDialogTitle class="modal-header">
    <h3>{{ (isEditMode ? 'pages.site_modal.edit_title' : 'pages.site_modal.title') | translate }}</h3>
    <button mat-icon-button class="red-color" (click)="closeModal()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form [formGroup]="siteForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="w-100 mt-1">
            <mat-label>{{ 'pages.site_modal.site_name' | translate }}</mat-label>
            <input matInput formControlName="label" [placeholder]="'pages.site_modal.site_name' | translate">
            <mat-error *ngIf="siteForm.controls.label.hasError('required')">
                {{ 'validations.required' | translate }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer" align="end">
    <div class="mandatory-note">
        <span class="required-marker">*</span> {{ 'pages.site_modal.mandatory' | translate }}
    </div>
    <div>
        <button mat-button (click)="closeModal()">
            {{ 'general.actions.cancel' | translate }}
        </button>
        <button mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!siteForm.valid || isSubmitting"
                (click)="onSubmit()">
            {{ (isEditMode ? 'general.actions.update' : 'general.actions.save') | translate }}
        </button>
    </div>
</mat-dialog-actions>
